import React from 'react'
import { CLASS_PREFIX } from 'src/constants'

import { ProjectDetailsIcon } from 'src/components/icons/projects/project-details'
import { textResources } from 'src/lang/de'
import { COLOR_TYPE_WHITE } from 'src/utils/color'
import './project_create_modal_header.scss'

const cls = `${CLASS_PREFIX}project-create-modal-header`

const t = textResources.projects

export const ProjectCreateModalHeader: React.FC = () => {
  return (
    <div className={cls}>
      <div className={`${cls}__badge`}>
        <ProjectDetailsIcon primaryColor={COLOR_TYPE_WHITE} />
      </div>
      <div className={`${cls}__title`}>{t.createProjectModal.headerTitle}</div>
    </div>
  )
}
